import { useEffect, useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getScreenIdFromRoute } from "../util/screens";
import { useAppStore } from "../store/store";

export default function PrivateRoutes() {
  const { user, form, screens, token, setScreenFromRoute } = useAppStore();
  const location = useLocation();

  // Auth state is derived from real token presence, not a synthetic userId.
  const isAuthorized = useMemo(() => !!token, [token]);

  // Handle deep linking and state restoration
  useEffect(() => {
    if (isAuthorized) {
      const screenId = getScreenIdFromRoute(location.pathname);

      // If we have a valid screen ID from the URL
      if (screenId) {
        // Update store with current screen
        setScreenFromRoute(location);
      } else {
        // No valid screen ID, redirect to default screen
        const defaultScreen = user.artesysPortfolioExists ? "1.11" : "1.5";
        setScreenFromRoute({ pathname: `/screen/${defaultScreen}` });
      }
    }
  }, [isAuthorized, location, setScreenFromRoute, user.artesysPortfolioExists]);

  // Handle unauthorized access
  if (!isAuthorized) {
    // Save attempted path for redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
